<template>
    <div>
        <div class="text-right" style="margin-top:-20px;">
            <button class="btn btn-sm btn-link" @click="checkAll(true)">{{ lang.polaris.form.select_all }}</button>
            <button class="btn btn-sm btn-link" @click="checkAll(false)">{{ lang.polaris.form.unselect_all }}</button>
        </div>

        <trax-ui-ajax-simple-table 
            :id="id+'-'+source" :header="header" :header-color="headerColor"
            :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
        </trax-ui-ajax-simple-table>

        <div class="text-right">
            <button class="btn btn-sm btn-link" @click="checkAll(true)">{{ lang.polaris.form.select_all }}</button>
            <button class="btn btn-sm btn-link" @click="checkAll(false)">{{ lang.polaris.form.unselect_all }}</button>
        </div>

        <div id="learner-attendance-check-template" v-show="false">
            <div class="form-check">
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input">
                    <span class="form-check-sign">
                        <span class="check"></span>
                    </span>
                </label>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-course-session-edit'},
            source: {default: '2'},
            target: {default: 'final'},
            header: { default: 0 },
            headerColor: { default: 'primary' },
            facesFolder: {default: app_url},
            facesDefault: {default: 'polaris/img/lib/misc/avatar.jpg'}
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/registrations/'+data.registration.id,
                endpointParams: {
                    accessors: ['members']
                },
                locations_names_uuid: data.locations_names_uuid,
                cols: [
                    {width: '50px'},
                    {},
                    {class: 'text-center'},
                    {class: 'text-center'},
                    {class: 'text-right'}
                ],
                learners : null,
                states : null,
                rows: [],
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-'+this.source+'-data', this.setData);
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-states-updated', this.updated);
        },
        
        methods: {
        
            setData(data) {
                var learners = data.data.members;
                learners.sort(function(a, b) {
                    if (a.lastname < b.lastname) return -1;
                    if (a.lastname > b.lastname) return 1;
                    return 0;
                });
                this.learners = learners;
                if (this.states) this.updateRows();
           },

            setStates(states) {
                this.states = states;
                if (this.learners) this.updateRows();
            },

            updateRows() {
                this.rows = [];
                for (var index in this.learners) {
                    var learner = this.learners[index];
                    this.rows.push([
                        this.picture(learner),
                        this.name(learner),
                        this.state(learner),
                        this.validation(learner),
                        this.checkbox(learner)
                    ]);
                }
            },

            updated(states) {
                this.setStates(states);
            },

            saveData(data) {
                data.learners = [];
                for (var index in this.learners) { 
                    var learner = this.learners[index];
                    var checked = $('.learner-check[data-learner-id='+learner.id+'] .form-check-input').prop('checked');
                    if (checked) data.learners.push(learner.id);
                }
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            },

            checkAll(check = true) {
                for (var index in this.learners) { 
                    var learner = this.learners[index];
                    var checkbox = $('.learner-check[data-learner-id='+learner.id+'] .form-check-input').prop('checked', check);
                }
            },

            
            //------------------------------- Columns rendering ----------------------------//


            picture(learner) {
                var src = learner.avatar ? learner.avatar : this.facesFolder + this.facesDefault;
                var html = '<img src="'+src+'" class="avatar">'
                return html;
            }, 

            name(learner) {
                var html = '<span class="font-weight-bold">'+learner.lastname + ' ' + learner.firstname+'</span>';
                var entity = '';
                if (learner.entity) entity = learner.entity.name;
                if (learner.subentity) entity += ' / ' + learner.subentity.name;
                html += '<br><small>'+entity+'</small>';
                return html;
            },

            state(learner) {
                var state = this.states[learner.id];
                if (!state) return '';
                var date = state.date;
                if (moment(date, 'YYYY-MM-DD', true).isValid()) date = moment(date).format('DD MMM YYYY');
                var html = '<span class="badge badge-success">' + date + '</span>';
                var name = this.locations_names_uuid[state.location.entity_uuid];
                if (!name) name = state.location.entity_name;
                html += '<br><small>' + name + '</small>';
                return html;
            },

            validation(learner) {
                var state = this.states[learner.id];
                if (state && state.validation) {
                    return '<small><i class="material-icons">done</i> ' + state.validation.user_name + '</small>';
                }
            },

            checkbox(learner) {
                var state = this.states[learner.id];
                var html = $('#learner-attendance-check-template').html();
                return '<div data-learner-id="'+learner.id+'" class="learner-check">'+html+'</div>';
            }

        }

    }
</script>
